<template>
  <div>
    <page-header :latestVersionUrl="latestVersionUrl" @log-out="logout" />

    <div align="center" id="licences-content">
      <div align="left">
        <back-button :backButtonText="backButtonText" @go-back="back" />
      </div>

      <h1 id="licence-title" align="left">Select your licence</h1>

      <div align="left" v-show="allLicences.length > 0">
        <b-input class="search-bar" align="left" placeholder="Search for a licence" v-model="licenceSearch" />
      </div>

      <div id="licence-list" v-show="!hasLoaded || licences.length > 0">
        <b-overlay :show="!hasLoaded" class="loading-overlay" bg-color="rgb((35, 37, 45)">
          <b-list-group v-show="licences.length > 0" v-for="(licence, index) in licences" :key="index">
            <b-list-group-item button class="list-item" @click="selectLicence(licence.id)">
              <div align="left" class="licence-name-div">
                <p class="licence-name">{{licence.name}}</p>
                <p class="licence-id">ID: {{licence.id}}</p>
              </div>
              <div align="right">
                <img class="chevron-right" src="@/assets/selector_chevron_right.png" alt="Chevron Right" />
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-overlay>
      </div>

      <div class="empty-warning" v-show="hasLoaded && allLicences.length <= 0">
        <p>You don’t have any licences associated to this account.</p>
        <br />
        <p>Think something is wrong? Email us at <u>customersuccess@cortextech.io</u> to let us know and we’ll add the correct licence(s) to your account.</p>
      </div>

      <div class="page-footer" />
    </div>
  </div>
</template>

<script>
import PageHeader from './PageHeader.vue'
import BackButton from './BackButton.vue'
export default {
  components: { PageHeader, BackButton },
  data() {
    return {
      allLicences: [],
      licences: [],
      hasLoaded: false,
      licenceSearch: '',
      backButtonText: 'Organisations'
    }
  },
  methods: {
    logout() {
      this.allLicences = []
      this.licences = []
      this.hasLoaded = false
      this.licenceSearch = ''
      this.$emit('log-out')
    },
    back() {
      this.allLicences = []
      this.licences = []
      this.hasLoaded = false
      this.licenceSearch = ''
      this.$emit('re-select-organisation')
    },
    selectLicence(licenceId) {
      this.licenceSearch = ''
      this.$emit("selected-licence-id", licenceId)
    },
    async getLicences() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + this.accessToken);
      myHeaders.append("Content-Type", "application/json");

      var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
      };

      const baseUrl = `https://${process.env.VUE_APP_DEPLOY_ENV === 'LIVE' ? '' : 'stage-'}cast-licensing-api.incrowdsports.com/v1`
      return await fetch(`${baseUrl}/licences?organisationId=${this.organisationId}`, requestOptions)
      .then(response => response.json())
      .then(data => {
        return data.data
      })
      .catch(error => console.log('error', error));
    },
    filterLicences() {
      if (this.licenceSearch.length <= 0) {
        this.licences = this.allLicences
      } else {
        this.licences = this.allLicences.filter(this.licenceSelector);
      }
    },
    licenceSelector(licence) {
      return licence.name.toUpperCase().includes(this.licenceSearch.toUpperCase());
    }
  },
  props: {
    accessToken: String,
    organisationId: String,
    latestVersionUrl: String
  },
  watch: {
    organisationId: {
      immediate: true,
      async handler() {
        if (this.organisationId.length > 0){
          this.allLicences = await this.getLicences()
          this.filterLicences()
          this.hasLoaded = true;
        }
        else {
          this.licences = []
        }
      }
    },
    licenceSearch: {
      immediate: true,
      handler() {
        this.filterLicences()
      }
    }
  },
}
</script>

<style>
#licences-content {
  padding-left: 10%;
  padding-right: 10%;
}
#licence-title {
  margin-top: 12px;
  text-align: left;
}
#licence-list {
  margin-top: 28px;
}
.licence-name-div {
  float: left;
  margin-left: 16px;
}
.licence-id {
  margin-top: -8px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;

  color: white;
}
@media screen and (max-width: 475px) {
  #licences-content {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>